// 作品封面按用途取不同尺寸的图，避免列表页拉 1600px 大图导致加载慢。
// 服务端在 data/uploads/covers 下同时存三档：
//   原名.webp      1600 宽，详情页/播放页用
//   原名-mid.webp   960 宽
//   原名-thumb.webp 480 宽，列表卡片用
// 非封面目录（外链、聊天图、帖子图）原样返回，不做处理。

const COVER_PREFIX = '/uploads/covers/';

export function coverUrl(url, size = 'thumb') {
  if (!url || typeof url !== 'string') return url;
  if (!url.startsWith(COVER_PREFIX)) return url;
  if (/-thumb\.webp$/i.test(url) || /-mid\.webp$/i.test(url)) return url;
  const suffix = size === 'mid' ? '-mid' : '-thumb';
  const next = url.replace(/\.(webp|jpe?g|png)$/i, suffix + '.webp');
  return next === url ? url : next;
}

// 图片加载失败时退回原图（历史封面可能没生成缩略图）
export function coverFallback(url) {
  if (!url || typeof url !== 'string') return url;
  return url.replace(/-(thumb|mid)\.webp$/i, '.webp');
}

export default coverUrl;
